import type { Document } from '@contentful/rich-text-types';
import { useTracking } from 'react-tracking';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Row } from '@simplywallst/ui-core';
import {
  AuthorWrapper,
  Avatar,
  AuthorBioSection,
  ProfileLink,
  AuthorName,
} from './styled';

type Props = {
  name: string;
  slug: string;
  photoURL: string;
  bio: Document | null;
};

export const AuthorWidget = ({ name, slug, photoURL, bio }: Props) => {
  const { trackEvent } = useTracking();
  const firstParagraph = bio && (bio.content[0] as unknown); // Only show the first paragraph from author bio
  return (
    <AuthorWrapper>
      <Row alignItem="center">
        <Avatar src={photoURL} alt={name} />
        <AuthorName>{name}</AuthorName>
      </Row>
      {firstParagraph ? (
        <Row>
          <AuthorBioSection>
            {documentToReactComponents(firstParagraph as Document)}
          </AuthorBioSection>
        </Row>
      ) : null}
      <Row>
        <ProfileLink
          href={`https://simplywall.st/news/about-simply-wall-st-news/${slug}`}
          target="_blank"
          onClick={() => {
            trackEvent({
              type: 'track',
              subject: 'author_sidebar',
              action: 'click',
              slug: slug,
            });
          }}
        >
          View Profile
        </ProfileLink>
      </Row>
    </AuthorWrapper>
  );
};
